<template>
    <div class="rounded shadow-lg modal-content-container">
        <div class="pt-3 px-3">
            <div>
                <h6><strong>Visit Address</strong></h6>
            </div>
        </div>
        <hr class="mb-2" />
        <div class="px-2">
            <form role="form">
                <div class="form-group mb-1">
                    <label for="addressLine1" class="control-label">Street Address</label>
                    <input
                        type="text"
                        v-model="addressDetails.AddressLine1"
                        id="addressLine1"
                        required="true"
                        class="form-control form-control-sm"
                    />
                </div>
                <div class="form-group mb-1">
                    <label for="addressLine2" class="control-label">Suite/Apt</label>
                    <input
                        type="text"
                        v-model="addressDetails.AddressLine2"
                        id="addressLine2"
                        required="true"
                        class="form-control form-control-sm"
                    />
                </div>
                <div class="form-group mb-1">
                    <label for="city" class="control-label">City</label>
                    <input type="text" v-model="addressDetails.City" id="city" class="form-control form-control-sm" />
                </div>
                <div class="form-group mb-1 row">
                    <div class="col-sm-5">
                        <label for="state" class="control-label">State</label>
                        <input
                            type="text"
                            v-model="addressDetails.StateCode"
                            id="state"
                            class="form-control form-control-sm"
                            maxlength="2"
                            minlength="2"
                        />
                    </div>
                    <div class="col-sm-4">
                        <label for="zipcode" class="control-label">ZIP</label>
                        <input
                            type="number"
                            v-model="addressDetails.ZipCode"
                            id="zipcode"
                            maxlength="5"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <span v-if="isAddressInvalid" class="text-danger"
                    >Please enter a street address, city, state and ZIP.</span
                >
            </form>
            <hr class="mt-1" />
        </div>
        <div class="mt-0 d-flex pb-2 pe-3 ps-3 justify-content-center">
            <button
                :disabled="!isAddressInvalid"
                @click="saveAddress"
                type="button"
                class="btn btn-xs me-2 btn-outline-primary"
            >
                Save
            </button>
            <button @click="cancel()" class="btn btn-xs btn-primary">Cancel</button>
        </div>
    </div>
</template>

<script lang="ts" src="./AddressModal.ts"></script>
